import _ from "lodash";
import React, { useCallback, useEffect, useMemo } from "react";
import { Button } from "reactstrap";
import {
  WOO_COMMERCE_GET_LOADING,
  WOO_COMMERCE_SYNC_LOADING,
} from "../../../../constants/loading.constant";
import { WOO_COMMERCE_BIND_FORM } from "../../../../constants/modal.constant";
import { useGlobalCore } from "../../../../cores/globals";
import { useMeCore } from "../../../../cores/me";
import {
  SocialProviderId,
  SocialProviderName,
} from "../../../../cores/socialPost/config";

import { useIntl } from "react-intl";
import { SocialProvider } from "../../../../cores/socialPost/interfaces/socialProvider";
import { useWooCommerceCore } from "../../../../cores/wooCommerce";
import SocialCard from "../SocialCard";
import { WooCommerceIcon } from "./WooCommerceIcon";

export default function WooCommerceAuthButton() {
  const intl = useIntl();
  const { get, settings, unbind, login } = useWooCommerceCore();
  const { company, getMeSocialSettings } = useMeCore();
  const { isLoading, turnOnModal } = useGlobalCore();

  useEffect(() => {
    get(company!.id);
  }, [company, get, login]);

  const isActive = useMemo((): boolean => !_.isEmpty(settings), [settings]);

  const socialProvider = useMemo(
    (): SocialProvider => ({
      id: SocialProviderId.WooCommerce,
      name: SocialProviderName.WooCommerce,
      icon: <WooCommerceIcon size="6x" active={isActive} />,
      displayName: settings?.name,
      url: settings?.url,
      avatar: settings?.avatarUrl,
    }),
    [isActive, settings]
  );

  const handleBind = useCallback(async () => {
    turnOnModal(WOO_COMMERCE_BIND_FORM, true);
  }, [turnOnModal]);

  const handleUnbind = useCallback(() => {
    unbind(company!.id, () => {
      getMeSocialSettings(company?.id!);
    });
  }, [company, unbind, getMeSocialSettings]);

  return (
    <Button
      className="w-100 mx-auto"
      color="primary"
      outline={isActive}
      onClick={!isActive ? handleBind : handleUnbind}
    >
      {!isActive
        ? intl.formatMessage({ id: "app.home.syncUp" })
        : intl.formatMessage({ id: "app.home.disconnect" })}
    </Button>
  );
}
